import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Pages/Layout/Layout";
import LoginPage from "./Pages/LoginPage/LoginPage";
import IngredientList from "./Pages/IngredientPage/IngredientPage";
import RecipeList from "./Pages/RecipePage/RecipePage"
import PlanList from "./Pages/PlannerPage/PlannerPage"
import ShoppingList from "./Pages/ShoppingListPage/ShoppingListPage"
import PrivateRoute from "./Pages/LoginPage/PrivateRoute";
import AuthorisationProvider from "./Pages/LoginPage/AuthorisationProvider";
import DataProvider from "./Pages/DataContext/DataProvider"
import './App.css'

function App() {

    return (
        <>
            <BrowserRouter>
                <AuthorisationProvider>
                    <DataProvider>
                        <Routes>
                            <Route path="Login" element={<LoginPage />} />
                            <Route element={<PrivateRoute/>}>
                                <Route path="/" element={<Layout />}>
                                    <Route index element={<IngredientList />} />
                                    <Route path="IngredientList" element={<IngredientList />} />
                                    <Route path="RecipeList" element={<RecipeList />} />
                                    <Route path="PlanList" element={<PlanList />} />
                                    <Route path="ShoppingList" element={<ShoppingList />} />
                                </Route>
                            </Route>
                        </Routes>
                    </DataProvider>
                </AuthorisationProvider>
            </BrowserRouter>
        </>
    )
}

export default App
